import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import { Paper, Stack, SxProps, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export function NoOrders({ customSx }: { customSx?: SxProps }) {
  const { t } = useTranslation();

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      flexDirection="row"
      gap={1}
      sx={customSx}
    >
      <Paper sx={{ padding: 2, width: "100%" }}>
        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          justifyContent="center"
        >
          <SentimentDissatisfiedIcon />
          <Typography>{t("no orders")}</Typography>
        </Stack>
      </Paper>
    </Stack>
  );
}
